import React, { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { OrderInterface } from "src/store/callrecorder/ordersSlice";
import { fetchOrders } from "src/actions/callrecorder/ordersActions";
import { formattedDate } from "src/helpers/DateHelpers";
import Pagination from "src/componets/Pagination";

import { Tag } from "antd";

interface ListTableInterface {
  filterParams: object;
  limit?: number;
}

const _ListTable = ({ filterParams, limit = 25 }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const ids = useAppSelector(state => state.callrecorder.orders.ids);
  const entities = useAppSelector(state => state.callrecorder.orders.entities);
  const count = useAppSelector(state => state.callrecorder.orders.count);
  const data = ids ? ids.map(id => entities[id]) : [];

  const urlOrderBy = searchParams.get('order_by') || '';
  const urlOrder = searchParams.get('order') || '';

  const params = useMemo(() => ({
    limit,
    ...filterParams,
    ...(urlOrderBy ? { order_by: urlOrderBy, order: urlOrder } : {})
  }), [limit, filterParams, urlOrderBy, urlOrder]);

  useEffect(() => {
    dispatch(fetchOrders(params));
  }, [params, dispatch]);

  const columns: ColumnsType<OrderInterface> = [
    {
      key: 'id',
      title: 'ID',
      render: (_, { id }) => <small>{`#${id}`}</small>,
      width: 60
    },

    {
      key: 'status',
      title: 'Status',
      render: (_, { status }) => {
        const color = status === 'completed' ? 'success'
          : status === 'pending' ? 'processing'
          : status === 'failed' ? 'error'
          : 'default';
        return <Tag color={color}>{status}</Tag>;
      },
      width: 90
    },

    {
      key: 'amount',
      title: 'Amount',
      render: (_, { amount }) => amount ? <small>{amount}</small> : '—',
      width: 80
    },

    {
      key: 'price',
      title: 'Price',
      render: (_, { price }) => price ? <small>{price}</small> : '—',
      width: 80
    },

    {
      key: 'productid',
      title: 'Product ID',
      render: (_, { productid }) => productid ? <small>{productid}</small> : '—',
      width: 120
    },

    {
      key: 'transaction_id',
      title: 'Transaction',
      render: (_, { transaction_id }) => <small>{transaction_id}</small>,
      width: 150
    },

    {
      key: 'code',
      title: 'Error Code',
      render: (_, { code }) => code !== null ? code : '—',
      width: 50
    },

    {
      key: 'created_at',
      title: 'Created',
      render: (_, { created_at }) => <small>{formattedDate(created_at).dateTime}</small>,
      width: 125
    },
  ];

  return (
    <div>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
        sort_keys={['id', 'amount', 'price', 'created_at']}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
